import React from "react";

// The banner every subpage opens with: one dimmed photo, a heading and an
// optional subheading.
const PageHero = ({ image, alt, title, subtitle }) => (
  <div className="slider-products">
    <img
      className="sliderphoto-products"
      width={1920}
      alt={alt}
      src={image}
    />
    <div className="slider-sale-and-text-products">
      <h1 className="slider-sale-products">{title}</h1>
      {subtitle && (
        <div className="slider-text-products">
          <h1 className="slider-text-sale-products">{subtitle}</h1>
        </div>
      )}
    </div>
  </div>
);

export default PageHero;
